import {
	Flex, Icon, Text, useSlotRecipe,
} from '@chakra-ui/react';
import type { FlexProps, RecipeVariantProps } from '@chakra-ui/react';
import React from 'react';

import type { iconLabelSlotRecipe } from '@/theme/slot-recipes/icon-label.slot-recipe';

type IconLabelRootProps = RecipeVariantProps<typeof iconLabelSlotRecipe> & FlexProps & {
	icon:  React.ElementType
	label: React.ReactNode
};

export const IconLabel = ({
	icon,
	iconStyle,
	label,
	variant,
	...flexProps
}: IconLabelRootProps) => {
	const recipe = useSlotRecipe({ key: 'iconLabel' });
	const styles = recipe({
		iconStyle,
		variant,
	});

	return (
		<Flex css={styles.root} {...flexProps}>
			<Icon as={icon as never} css={styles.icon} />
			<Text css={styles.label}>
				{label}
			</Text>
		</Flex>
	);
};
